import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ILoadingStation } from 'src/app/storage/interfaces/loading-station.interface';
import { LoadingStation } from 'src/app/storage/models/loading-station.model';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class LoadingStationsService {

  constructor(
    private translateService: TranslateService,
    private apiService: ApiService
  ) { }

  async getLoadingStations(): Promise<LoadingStation[] | null> {
    const translations = await this.translateService.get('LOADING_STATIONS').toPromise();

    const response = await this.apiService.get(
      `${URL}loading-stations`,
      translations['LABEL']
    );

    return response ?
          response.loadingStations.map((loadingStation: ILoadingStation) => new LoadingStation(loadingStation)) :
          null;
  }
}
